
if($('#category-header').length){
    function mhfiltr() {
      $('.slider-wrapper').wrapInner('<div class="pricefilter"></div>');
      $('.slider-wrapper h4').insertBefore('.pricefilter');
      $('.filter-section h4').click(function(){
          $(this).closest('.filter-section').toggleClass('close');
      });
      $('.slider-wrapper h4').click(function(){
          $(this).closest('.slider-wrapper').toggleClass('close');
      });
          
      }

      $(document).ready(function() { 
      mhfiltr(); 
    
  });  
  document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    mhfiltr();
   
  });  

}
